<template>
    
    <div class="single-product__size-guide pt_cs_meaning_guide" data-index="1">
        <div class="single-product__size-guide-container">
            <a class="single-product__size-guide--btn" @click="show_guide__popup">Meaning Guide</a><img alt="alert-info"  src="/single-product/alert-info-icon.webp">
        </div>
        <div class="size-guide__popup " ref="popupRef" id="size-guide__popup-1" :class="open ? 'active' : ''">
            <div class="size-guide__content " ref="contentRef">
                <h4 class="size-guide__heading">Gemstones meaning<span class="pt_custom_text">Each gemstone carries its own symbolic meaning. Explore the guide below and choose the intention that resonates with you.</span></h4>
                <div class="size-guide__tab-panel">
                    <span data-tab="size-chart" class="size-guide__tab pt_tab size-guide__tab--size-chart" :class="{ 'active-tab': currentTab === 'size' }" @click="handleChainTab('size')">Classic beads</span>
                    <span data-tab="guide" class="size-guide__tab pt_tab size-guide__tab--guide" :class="{ 'active-tab': currentTab === 'measurement' }" @click="handleChainTab('measurement')">Deluxe beads</span>
                    <span data-tab="elemental" class="size-guide__tab pt_tab size-guide__tab--guide" :class="{ 'active-tab': currentTab === 'elemental' }" @click="handleChainTab('elemental')">Elemental beads</span>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--size-chart" :class="{ 'active-tab': currentTab === 'size' }">
                    <div class="custom_size_guide_bracelet size_guide_pixiu_bracelet">
                        <div class="size-guide__size-chart custom_meaning_guide"
                        >
                            <table>
                                <tbody>
                                    <tr v-for="(row, rowIndex) in classicBeads" :key="rowIndex">
                                        <td v-if="rowIndex === 0">{{ row[0] }}</td>
                                        <td v-else class="bead-cell">
                                            <img :src="row[0]" :alt="row[1]" class="bead-image">
                                            <span class="bead-name">{{ row[1] }}</span>
                                        </td>
                                        <td>{{ rowIndex === 0 ? row[1] : row[2] }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="size-guide__size-chart--text custom_text_p" >
                            <p style="text-align: center; width: 75%; font-weight: 400;margin: 0 auto; text-transform: none;">While meaning can guide your choice, the best gemstone is ultimately the one you feel most drawn to.</p>
                        </div>
                    </div>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--size-chart" :class="{ 'active-tab': currentTab === 'measurement' }">
                    <div class="custom_size_guide_bracelet size_guide_pixiu_bracelet">
                        <div class="size-guide__size-chart custom_meaning_guide"
                        >
                            <table>
                                <tbody>
                                    <tr v-for="(row, rowIndex) in deluxeBeads" :key="rowIndex">
                                        <td v-if="rowIndex === 0">{{ row[0] }}</td>
                                        <td v-else class="bead-cell">
                                            <img :src="row[0]" :alt="row[1]" class="bead-image">
                                            <span class="bead-name">{{ row[1] }}</span>
                                        </td>
                                        <td>{{ rowIndex === 0 ? row[1] : row[2] }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="size-guide__size-chart--text custom_text_p" >
                            <p style="text-align: center; width: 75%;font-weight: 400;margin: 0 auto; text-transform: none;">While meaning can guide your choice, the best gemstone is ultimately the one you feel most drawn to.</p>
                        </div>
                    </div>
                </div>
                <div class="size-guide__tab-content size-guide__tab-content--size-chart" :class="{ 'active-tab': currentTab === 'elemental' }">
                    <div class="custom_size_guide_bracelet size_guide_pixiu_bracelet">
                        <div class="size-guide__size-chart custom_meaning_guide"
                        >
                            <table>
                                <tbody>
                                    <tr v-for="(row, rowIndex) in elementalBeads" :key="rowIndex">
                                        <td v-if="rowIndex === 0">{{ row[0] }}</td>
                                        <td v-else class="bead-cell">
                                            <img :src="row[0]" :alt="row[1]" class="bead-image">
                                            <span class="bead-name">{{ row[1] }}</span>
                                        </td>
                                        <td>{{ rowIndex === 0 ? row[1] : row[2] }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="size-guide__size-chart--text custom_text_p" >
                            <p style="text-align: center; width: 75%;font-weight: 400;margin: 0 auto; text-transform: none;">While meaning can guide your choice, the best gemstone is ultimately the one you feel most drawn to.</p>
                        </div>
                    </div>
                </div>
                <div class="size-guide__footer">
                    <a @click="close_guide__popup" class="size-guide__close"><span>Continue Shopping</span></a>
                </div>
                <span class="size-guide__close-btn" @click="close_guide__popup">
                    <svg class="icon_close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"/></svg>
                </span>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_sizeguide.scss";
    .pt_custom_text {
        display: block;
        font-size: 14px;
        max-width: calc(100% - 120px);
        margin: 0 auto;
        font-weight: 400;
        margin-top: 10px;
        line-height: 1.5;
        @media screen and (max-width: 768px) {
            max-width: calc(100% - 60px);
        }
    }
    .custom_size_guide_bracelet {
        .custom_pixiu_img {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            .swiper-wrapper {
                align-items: start !important;
            }
            .pixiu-swiper {
                width: 100%;
            }

            .pt_cs_item {
                display: flex;
                flex-direction: column;
                justify-content: center;
                .sub_title_img {
                    margin-top: 10px;
                    font-size: 14px;
                    color: #212529;
                }
            }

            img {
                width: 100%;
                height: 350px;
                object-fit: cover;
                @media screen and (max-width: 575px) {
                    height: 250px;
                }
            }

            .pixiu-navigation-controls {
                .pixiu-nav-btn {
                    background: #ffffff;
                    border: 1px solid #ffffff;
                    border-radius: 50%;
                    width: 35px;
                    height: 35px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    z-index: 9999;
                    box-shadow: 0 2px 10px #00000040;
                    &.pixiu-prev-btn {
                        position: absolute;
                        left: 10px;
                        top: calc(50% - 45px);
                        // transform: translateY(-50%);
                    }

                    &.pixiu-next-btn {
                        position: absolute;
                        right: 10px;
                        top: calc(50% - 45px);
                        // transform: translateY(-50%);
                    }

                    img {
                        width: 20px;
                        height: 20px;
                        color: #212529;
                    }

                    .nav-arrow-right {
                        transform: rotate(180deg);
                    }

                    &:disabled,
                    &[disabled] {
                        opacity: 0 !important;
                        cursor: auto !important;
                    }

                    &:not(:disabled):hover {
                        // background: #212529;
                        // border: 1px solid #c60c46;
                        svg {
                            color: #fff;
                        }
                    }
                }
            }
        }

        .bead-cell {
            display: flex;
            align-items: center;
            gap: 12px;

            .bead-image {
                width: 45px;
                height: 45px;
                object-fit: cover;
                border-radius: 4px;
                flex-shrink: 0;
                margin-right: 10px;
                @media screen and (max-width: 768px) {
                    margin-right: 7px;
                    width: 40px;
                    height: 40px;
                }
            }

            .bead-name {
                font-weight: 500;
                color: #212529;
                vertical-align: middle !important;
                display: inline-block !important;
                line-height: normal;
            }
        }
    }
</style>

<script setup lang="ts">
    import 'swiper/css';
    import 'swiper/css/navigation';
    import amImg from '@/assets/images/single-product/AM.jpg';
    import baGaImg from '@/assets/images/single-product/BA-GA.jpg';
    import baWdImg from '@/assets/images/single-product/BA-WD.jpg';
    import baImg from '@/assets/images/single-product/BA.jpg';
    import ga1Img from '@/assets/images/single-product/GA_1.jpg';
    import raImg from '@/assets/images/single-product/RA.jpg';
    import rqImg from '@/assets/images/single-product/RQ.jpg';
    import teGdImg from '@/assets/images/single-product/TE-GD.jpg';
    import teImg from '@/assets/images/single-product/TE.jpg';
    import waImg from '@/assets/images/single-product/WA.jpg';
    import rteImg from '@/assets/images/single-product/RTE.jpg';
    import avImg from '@/assets/images/single-product/AV.jpg';
    import bteImg from '@/assets/images/single-product/BTE.jpg';
    import webhs from '@/assets/images/single-product/Wood Element Beads Half Swatch.jpg';
    import eebhs from '@/assets/images/single-product/Earth Element Beads Half Swatch.jpg';
    import mebhs from '@/assets/images/single-product/Metal Element Beads Half Swatch.jpg';
    import febhs from '@/assets/images/single-product/Fire Element Beads Half Swatch.jpg';
    import waebhs from '@/assets/images/single-product/Water Element Beads Half Swatch.jpg';

    const currentTab = ref('size');
    const currentPixiuSlide = ref(0);
    const totalPixiuSlides = ref(0);
    const swiperInstance = ref<any>(null);

    const classicBeads = ref([
        ["Beads", "Symbolic Meaning"],
        [amImg, "Amethyst", "Clarity and calm judgement"],
        [baImg, "Black Agate", "Protection and steady stability"],
        [baWdImg, "Black Agate Word", "Confidence, drive and forward momentum"],
        [ga1Img, "Green Agate", "Growth, renewal and fresh beginnings"],
        [raImg, "Red Agate", "Confidence, drive and forward momentum"],
        [rqImg, "Rose Quartz", "Harmony, warmth and emotional balance"],
        [teImg, "Tiger Eye", "Courage, focus and self-assurance"],
        [teGdImg, "Tiger Eye Gold Dragon", "Strength and ambition"],
        [waImg, "White Agate", "Clarity, composure and grounded thinking"],
    ]);
    const deluxeBeads = ref([
        ["Beads", "Symbolic Meaning"],
        [avImg, "Aventurine", "New opportunities and steady growth"],
        [bteImg, "Blue Tiger Eye", "Focus and steady strength"],
        [rteImg, "Red Tiger Eye", "Bold ambition and forward drive"],
    ]);
    const elementalBeads = ref([
        ["Beads", "Symbolic Meaning"],
        [eebhs, "Earth Element 土", "Stability and a grounded foundation"],
        [febhs, "Fire Element 火", "Drive and transformative energy"],
        [mebhs, "Metal Element 金", "Clarity and disciplined strength"],
        [waebhs, "Water Element 水", "Smooth flow and adaptive wisdom"],
        [webhs, "Wood Element 木", "Growth and new beginnings"],
    ]);

    const open = ref(false)
    const show_guide__popup = () =>{
        currentTab.value = 'size';
        open.value = true,
        document.body.style.overflowY = 'hidden';
        setTimeout(() => {
            document.addEventListener('click', handleClickOutside);
        }, 300);
    }
    const close_guide__popup = () =>{
        open.value = false,
        document.body.style.overflowY = 'scroll';
        document.removeEventListener('click', handleClickOutside);
    }
    const handleChainTab = (tab: string) => {
        currentTab.value = tab;
    }
    const popupRef = ref<HTMLElement | null>(null);
    const contentRef = ref<HTMLElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
        if (contentRef.value && !contentRef.value.contains(event.target as Node)) {
            close_guide__popup();
        }
    };

    const handlePrevClick = () => {
        swiperInstance.value?.slidePrev();
    };

    const handleNextClick = () => {
        swiperInstance.value?.slideNext();
    };

    const handleSlideChange = () => {
        if (swiperInstance.value) {
            currentPixiuSlide.value = swiperInstance.value.activeIndex;
            totalPixiuSlides.value = swiperInstance.value.slides.length;
        }
    };

    const onSwiperInit = (swiper: any) => {
        swiperInstance.value = swiper;
        totalPixiuSlides.value = swiper.slides.length;
    };

    const props = defineProps(["isCustomise", "breadCrumbChild"]);
    const isCustomise = computed(() => props.isCustomise);
    const isBreadCrumbChildPixiu = computed(() => props.breadCrumbChild);
</script>